import styled from '@emotion/styled'
import { theme } from 'app/theme/index'
import { rgba } from 'emotion-rgba'
import { compact } from 'lodash'
import React, { memo } from 'react'

import { Item, Props as ItemProps } from './Item'

export interface Props {
  languageCode?: string
  sidebarItems: { [key: string]: ItemProps[] }[]
}

export const Sidebar = memo(function Sidebar({
  languageCode,
  sidebarItems,
}: Props) {
  if (!sidebarItems) {
    return null
  }

  return (
    <Container>
      {sidebarItems.map((item: any, index) => (
        <Item key={index} {...item} />
      ))}
    </Container>
  )
})

const Container = styled.aside`
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 4;

  @media (max-width: 1199px) {
    display: flex;
    background: ${({ theme }) => theme.colors.variants.neutralDark1};
    box-shadow: ${rgba(theme.colors.variants.neutralDark0, 0.12)} 0 3px 16px;
    top: auto;
    bottom: 0;
    left: 0;
    transform: none;
  }
`
